import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import store from './states/store';
import App from './App';

import 'antd/dist/antd.css';
import 'assets/css/global.scss';
import 'assets/css/core/helper.css';
import TagManager from 'react-gtm-module';

import { GoogleOAuthProvider } from '@react-oauth/google';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
};

const clientId = process.env.REACT_APP_GG_CLIENT_ID;

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={clientId}>
      <App />
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById('turnitblue-content')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
